export const IsConfirm = Object.freeze({
  Yes: 1,
  No: 0,
})

export const MakeCollectionsStatusList = [
  { name: 'statistics_performance_receipt_status_0', id: 0 },
  { name: 'statistics_performance_receipt_status_1', id: 1 },
  { name: 'statistics_performance_receipt_status_2', id: 2 },
  { name: 'statistics_performance_receipt_status_5', id: 5 },
]

export const capacityTabList = Object.freeze({
  userCapacity: '0',
  taskCapacity: '1',
})

export const RegistrationTimeType = Object.freeze({
  None: -1,
  TimeInterval: 0,
  Countdown: 1,
})
